import styled from 'styled-components';

export const CompanyBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CompanyContainerOpen = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  height: 35px;

  border-radius: 3px;
  width: 90%;
`;

export const CompanyContainerClosed = styled.div`
  position: relative;
  left: -8px;
  height: 35px;
  width: max-content;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 5px;
  border-radius: 7px;
  > span {
    font-size: 14px;
  }
`;
